"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortingDirection = void 0;
var SortingDirection;
(function (SortingDirection) {
    SortingDirection[SortingDirection["Ascending"] = 1] = "Ascending";
    SortingDirection[SortingDirection["Descending"] = 2] = "Descending";
})(SortingDirection = exports.SortingDirection || (exports.SortingDirection = {}));
//# sourceMappingURL=SortingDirection.js.map